import React, { useState } from "react";
import { Scissors, Sparkles, Flower2, Hand, Zap, Eye } from "lucide-react";

const ICONS = {
  Hair: Scissors,
  Nails: Hand,
  Facials: Sparkles,
  Threading: Eye,
  Waxing: Flower2,
  "Laser Hair Removal": Zap,
};

export default function Services({ services, onBookService }) {
  const categories = Object.keys(ICONS);
  const [active, setActive] = useState("Hair");

  const filtered = services.filter((s) => s.category === active);

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div
        className="pink-glow-blob"
        style={{ width: 600, height: 600, background: "rgba(255, 32, 121, 0.12)", top: "30%", left: "-200px" }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <div className="eyebrow mb-4">The Menu</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-tight">
            Curated rituals.
            <br />
            <span className="italic text-[#FF2079]">Honest pricing.</span>
          </h2>
          <p className="mt-6 text-[#A09CA3] text-base leading-relaxed max-w-xl">
            From precision cuts to restorative laser therapy — every service
            is delivered by certified specialists in our private studio.
          </p>
        </div>

        {/* Category tabs */}
        <div className="flex flex-wrap gap-2 mb-12">
          {categories.map((cat) => {
            const Icon = ICONS[cat];
            const isActive = active === cat;
            return (
              <button
                key={cat}
                data-testid={`service-cat-${cat.toLowerCase().replace(/\s+/g, "-")}-btn`}
                onClick={() => setActive(cat)}
                className={`flex items-center gap-2 px-5 py-3 rounded-sm text-[11px] tracking-[0.22em] uppercase transition-all duration-300 border ${
                  isActive
                    ? "bg-[#FF2079] text-white border-[#FF2079] shadow-[0_0_24px_rgba(255,32,121,0.45)]"
                    : "bg-transparent text-[#A09CA3] border-white/10 hover:border-white/30 hover:text-white"
                }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {cat}
              </button>
            );
          })}
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {filtered.map((svc) => (
            <div
              key={svc.id}
              data-testid={`service-card-${svc.id}`}
              className="glass-card rounded-sm p-7 group cursor-pointer"
              onClick={() => onBookService(svc)}
            >
              <div className="flex items-start justify-between gap-6">
                <div className="flex-1">
                  {svc.is_special && (
                    <span data-testid={`service-special-badge-${svc.id}`} className="inline-block mb-2 text-[9px] tracking-[0.3em] uppercase text-white bg-[#FF2079] px-2 py-1 rounded-sm">
                      Special Offer
                    </span>
                  )}
                  <div className="font-display text-2xl text-white group-hover:text-[#FF2079] transition-colors">
                    {svc.name}
                  </div>
                  <p className="mt-2 text-sm text-[#A09CA3] leading-relaxed">
                    {svc.description}
                  </p>
                  <div className="mt-4 text-[10px] tracking-[0.3em] uppercase text-[#FFB6C1]/70">
                    {svc.duration_min} minutes
                  </div>
                </div>
                <div className="text-right">
                  <div data-testid={`service-price-${svc.id}`} className="font-display text-2xl md:text-3xl text-[#FF2079] whitespace-nowrap">
                    {svc.price_label || `$${svc.price}`}
                  </div>
                  {svc.regular_price_label && (
                    <div className="text-xs text-[#A09CA3] line-through">{svc.regular_price_label}</div>
                  )}
                  <button
                    data-testid={`book-service-${svc.id}-btn`}
                    onClick={(e) => {
                      e.stopPropagation();
                      onBookService(svc);
                    }}
                    className="mt-4 text-[10px] tracking-[0.3em] uppercase text-white/70 hover:text-[#FF2079] transition-colors"
                  >
                    Book →
                  </button>
                </div>
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <div className="md:col-span-2 text-center py-12 text-[#A09CA3]">
              No services available in this category.
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
